module.exports = __webpack_public_path__ + "img/1autorent-www_color.6c874e57.svg";